class HeroTicker extends HTMLElement {
  connectedCallback() {
    if (this.ready) return
    this.track = this.querySelector('[data-ticker-track]')
    if (!this.track) return

    this.count = this.track.children.length
    if (this.count < 2) return
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    this.hold = parseInt(this.dataset.hold, 10) || 2000
    this.speed = parseInt(this.dataset.speed, 10) || 1000
    this.index = 0
    this.ready = true

    const clone = this.track.firstElementChild.cloneNode(true)
    clone.setAttribute('aria-hidden', 'true')
    this.track.appendChild(clone)

    this.observe()
  }

  disconnectedCallback() {
    this.stop()
    if (this.observer) this.observer.disconnect()
  }

  observe() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.start()
        } else {
          this.stop()
        }
      })
    })
    this.observer.observe(this)
  }

  start() {
    if (this.timer) return
    this.timer = setInterval(() => this.next(), this.hold + this.speed)
  }

  stop() {
    clearInterval(this.timer)
    this.timer = null
  }

  next() {
    this.index += 1
    this.track.style.transition = `transform ${this.speed}ms ease`
    this.track.style.transform = `translateY(-${this.index * 100}%)`

    if (this.index === this.count) {
      setTimeout(() => {
        this.index = 0
        this.track.style.transition = 'none'
        this.track.style.transform = 'translateY(0)'
      }, this.speed)
    }
  }
}

if (!customElements.get('hero-ticker')) {
  customElements.define('hero-ticker', HeroTicker)
}